import React from 'react';
import { Element } from './CardEbook.styles';
import { Title } from '@/components/typography';
import Image from '@/providers/Image';

export interface CardEbookProps {}

const CardEbook = ({ ...props }: CardEbookProps) => {
  return (
    <Element>
      <Title as="h3" weight="semi_bold" textCase="uppercase" color="secondary_500" size="base">
        Conheça o E-Book Lua de Mel
      </Title>
      <a title="E-book Lua de Mel" href="https://conteudo.kangaroo.com.br/lua-de-mel-selecao" target="_blank">
        <Image
          src="https://assets-cdn.kangaroo.com.br/images/content/capa-ebook-lua-de-mel.jpg"
          alt="Lua de Mel"
          width="300"
          height="225"
        />
      </a>
    </Element>
  );
};

export default CardEbook;
